import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import BackupRestoreList from './containers/BackupRestoreList';
import BackupRestoreCreate from './containers/BackupRestoreCreate';
import { SYSTEM_CONFIGURATION_ROUTE, BACKUP_RESTORE, SYSTEM } from '../../constants';

interface Props {
}

const BackupRestore: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${BACKUP_RESTORE}`}>
        <BackupRestoreList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${BACKUP_RESTORE}/create`}>
        <BackupRestoreCreate />
      </Route>
    </Fragment>
  );
};

export default BackupRestore;
